import {
  SET_EDIT_MODE,
  SAVE_TEMPORARY_APPOINTMENT,
  REPLACE_TIME_FILTERS,
  SAVE_TEMPORARY_JOURNEY_STATE,
} from './edit-appointment.actions';

const initialState = {
  editMode: false,
  timeFilters: [],
  temporaryAppointment: {},
  temporaryJourneyState: {},
};

export const editAppointment = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_EDIT_MODE:
      return {
        ...state,
        editMode: payload,
      };
    case SAVE_TEMPORARY_APPOINTMENT:
      return {
        ...state,
        temporaryAppointment: payload,
      };
    case REPLACE_TIME_FILTERS:
      return {
        ...state,
        timeFilters: payload,
      };
    case SAVE_TEMPORARY_JOURNEY_STATE:
      return {
        ...state,
        temporaryJourneyState: payload,
      };
    default:
      return state;
  }
};
